// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"a5f7627e","462":"1ccca772","611":"36ac5309"}[chunkId] + ".chunk.js";
};